import request from '@/lib/request/'

const baseUri = 'tag'

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/tag/index.js